import { render, staticRenderFns } from "./ManageAwardsDialog.vue?vue&type=template&id=0fd80a78"
import script from "./ManageAwardsDialog.vue?vue&type=script&lang=js"
export * from "./ManageAwardsDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageAwardsDialog.vue?vue&type=style&index=0&id=0fd80a78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports